import { queryOptions } from "@tanstack/react-query";
import { backendService } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_coreValuesSummary = (
	query: Parameters<typeof backendService.corevalues.coreValuesControllerGetReflectionSummary>[0],
) =>
	queryOptions({
		queryKey: ["core-values", "summary", query] as const,
		queryFn: (context) =>
			extractionWrapper(
				backendService.corevalues.coreValuesControllerGetReflectionSummary(context.queryKey[2], {
					signal: context.signal,
					format: "text",
				}),
			),
	});
